import { render, staticRenderFns } from "./CardRegion.vue?vue&type=template&id=a250e1b2&scoped=true&"
import script from "./CardRegion.vue?vue&type=script&lang=js&"
export * from "./CardRegion.vue?vue&type=script&lang=js&"
import style0 from "./CardRegion.vue?vue&type=style&index=0&id=a250e1b2&lang=scss&scoped=true&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fcard-region&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a250e1b2",
  null
  
)

export default component.exports